import { RouteProvider } from "views/components/Provider";
import {
	isDniRequired as isDniRequiredFn,
	isRutRequired as isRutRequiredFn,
} from "lib/helpers/documents";
import { or } from "ramda";
import { pathOr } from "lib/functions";
import { useAuth } from "hooks/useAuth";
import { useEffect } from "react";
import { useGlobal, useState } from "reactn";
import { useOffice } from "state/offices/hooks";
import { useQuery } from "hooks/useQuery";
import { validatePhone } from "lib/rut";

const RequestReservation = ({ match, history, children }) => {
	let query = useQuery();
	const [user] = useGlobal("user");
	const [newTicket] = useGlobal("newTicket");
	const [loginModalState, setLoginModalState] = useState("");

	const [registerModalState, setRegisterModalState] = useState("");
	const [rutRequired, setRutRequired] = useState(null);
	const [phoneRequired, setPhoneRequired] = useState(null);
	const [isUnexistRequiredField, setIsUnexistRequiredField] = useState(false);
	const [meetOrFace, setMeetOrFace] = useState(false);
	const [isReservation, setIsReservation] = useState(false);
	const [openRutUpdate, setOpenRutUpdate] = useState(false);
	const officeSlug = match.params.office;
	const [office, officeLoading] = useOffice(officeSlug);
	const lineSlug = match.params.line;
	const line = pathOr(null, ["lines", lineSlug], office);

	const [wantTemporary, setWantTemporary] = useState(false);
	const [isRutUpdating, setIsRutUpdating] = useState(false);
	const [isRutModalVisible, setIsRutModalVisible] = useState(false);
	const [temporaryRut, setTemporaryRut] = useState("");
	const [temporaryDni, setTemporaryDni] = useState("");

	const [modalWithoutLoginState, setModalWithoutLoginState] =
		useState("closed");
	const [isVisibleConfirmationModal, setIsVisibleConfirmationModal] =
		useState(false);
	const temporaryPath = query.get("temporary");
	const showOnlyTemporaryForm = temporaryPath ? true : false;
	const v2 = office && office.options && office.options.reservations_v2;
	const hasRut = user && user.rut && user.rut.length > 0 ? true : false;

	const hasPhone =
		user && user.phone && user.phone.length > 0 && validatePhone(user.phone)
			? true
			: false;
	const hasDni = user && user.dni && user.dni.length > 0 ? true : false;
	const rutOrDni = or(hasRut ? true : false, hasDni ? true : false);
	const reservationsOptions = pathOr(
		"unexist",
		["options", "reservations", "fields"],
		office
	);
	const attention_type = pathOr(
		false,
		["options", "reservations", "attention_type"],
		office
	);

	const disabledReservationsFromLine = pathOr(
		false,
		["meta", "disabled_reserves"],
		line
	);

	const disabledReservationFromOffice =
		office?.options?.attention_type?.reservations;

	const shouldRedirect = (lineDisable, officeDisable) => {
		if (officeDisable === false) return true;
		if (lineDisable) return true;
		return false;
	};

	const { isLoggedInTemporary, isLoggedIn } = useAuth();
	const modeRut = pathOr(false, ["options", "mode_rut"], office);
	const modeDni = pathOr(false, ["options", "dni_peru"], office);

	const isDniRequired = isDniRequiredFn({
		hasDni,
		isLoggedIn,
		isLoggedInTemporary,
		modeDni,
		modeRut,
	});

	const isRutRequired = isRutRequiredFn({
		hasRut,
		isLoggedIn,
		isLoggedInTemporary,
		modeRut,
		modeDni,
	});

	const RedirectRouter = `/offices/${officeSlug}/lines/${lineSlug}`;

	const RedirectFunction = (lineDisable, officeDisable) => {
		if (shouldRedirect(lineDisable, officeDisable)) {
			history.push(RedirectRouter);
		}
		return null;
	};

	useEffect(() => {
		if (office && line) {
			RedirectFunction(
				disabledReservationsFromLine,
				disabledReservationFromOffice
			);
		}
	}, [office, line]);

	const documentModalType = isDniRequired ? "dni" : "rut";

	useEffect(() => {
		if (rutRequired && phoneRequired) {
			!rutRequired.required &&
				!phoneRequired.required &&
				setIsUnexistRequiredField(true);
		}
	}, [rutRequired, phoneRequired]);
	useEffect(() => {
		office &&
			reservationsOptions !== "unexist" &&
			reservationsOptions.length &&
			reservationsOptions.map((field) => {
				if (field.field === "dni") {
					setRutRequired(field);
				}
				if (field.field === "phone") {
					setPhoneRequired(field);
				}
			});

		office &&
			reservationsOptions &&
			reservationsOptions === "unexist" &&
			setIsUnexistRequiredField(true);
	}, [reservationsOptions, office]);

	const ticketAction = () => {
		if (user.guest) {
			isActiveLoginModal();
		}
	};

	const loginModalIsVisible = loginModalState === "open";

	const closeLoginModal = () => {
		setLoginModalState("closed");
	};

	const isActiveLoginModal = () => {
		if (user.guest) {
			setIsReservation(true);
			setLoginModalState("open");
		} else {
			ticketAction();
		}
	};

	const activeSignUpModalInTemporaryUser = () => {
		setRegisterModalState("open");
	};
	const signUpModalIsVisible = registerModalState === "open";
	const isActiveRegistryModal = () => {
		if (loginModalState === "open") {
			setLoginModalState("close");
			setRegisterModalState("open");
		} else {
			ticketAction();
		}
	};
	const closeSignUpModal = () => setRegisterModalState("closed");

	const handlerWithoutLoginModal = () => {
		closeSignUpModal();
		closeLoginModal();
		setModalWithoutLoginState("open");
	};

	const closeReserveWihtoutLogin = () => {
		setModalWithoutLoginState("closed");
	};
	const isVisibleModalWithoutLogin =
		loginModalState === "closed" && modalWithoutLoginState === "open";

	const handleOpenUpdateRutModal = () => {
		if (rutOrDni && phoneRequired && !phoneRequired.required) {
			return false;
		}

		if (isUnexistRequiredField) {
			return false;
		}
		if (rutOrDni && hasPhone) {
			return false;
		}
		return true;
	};

	const meetAttentionType =
		attention_type === "videocall" || attention_type === "meet"
			? true
			: false;
	const handleMeet = () => {
		if (meetAttentionType) {
			return true;
		}
		if (meetOrFace && meetOrFace === "videocall") {
			return true;
		}

		return false;
	};

	return children({
		activeSignUpModalInTemporaryUser,
		attention_type,
		closeLoginModal,
		closeReserveWihtoutLogin,
		closeSignUpModal,
		documentModalType,
		handleMeet,
		handleOpenUpdateRutModal,
		handlerWithoutLoginModal,
		hasDni,
		hasPhone,
		hasRut,
		history,
		isActiveLoginModal,
		isActiveRegistryModal,
		isDniRequired,
		isRutModalVisible,
		isRutRequired,
		isRutUpdating,
		isUnexistRequiredField,
		isVisibleConfirmationModal,
		isVisibleModalWithoutLogin,
		loginModalIsVisible,
		match,
		newTicket,
		office,
		officeLoading,
		officeSlug,
		openRutUpdate,
		phoneRequired,
		rutOrDni,
		rutRequired,
		setIsRutModalVisible,
		setIsRutUpdating,
		setIsVisibleConfirmationModal,
		setMeetOrFace,
		setOpenRutUpdate,
		setTemporaryDni,
		setTemporaryRut,
		setWantTemporary,
		showOnlyTemporaryForm,
		signUpModalIsVisible,
		temporaryDni,
		temporaryPath,
		temporaryRut,
		ticketAction,
		user,
		v2,
		wantTemporary,
		line,
	});
};

export default RouteProvider(RequestReservation);
